import { cva, type VariantProps } from 'class-variance-authority';

/**
 * HEN SectionHeader variants using HEN Design System tokens.
 * All styling references design tokens defined in tailwind.config.ts.
 */
export const sectionHeaderVariants = cva(['flex flex-col'], {
  variants: {
    align: {
      left: ['items-start', 'text-left'],
      center: ['items-center', 'text-center'],
    },
  },
  defaultVariants: {
    align: 'left',
  },
});

export type SectionHeaderVariantProps = VariantProps<
  typeof sectionHeaderVariants
>;
